import { connect } from 'react-redux';

// actions
import { setFocus } from 'modules/focus-observer/focus-observer.actions';

// types
import IConfig from '@sitegen/common/constants/config';
import RootComposerComponent from './root-composer.component';

const mapStateToProps = (state: { config: IConfig }) => ({
    config: state.config
});

const mapDispatchToProps = {
    setFocus
};

const RootComposerContainer = connect(mapStateToProps, mapDispatchToProps)(RootComposerComponent);

export default RootComposerContainer;
